import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { dismissRefreshItem, getRefreshList, sendRefreshItem } from '../api/content-refresh';

const KEY = ['content-refresh'] as const;

export function useRefreshList() {
  return useQuery({ queryKey: KEY, queryFn: () => getRefreshList() });
}

export function useSendRefreshItem() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: sendRefreshItem, onSuccess: () => qc.invalidateQueries({ queryKey: KEY }) });
}

export function useDismissRefreshItem() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: dismissRefreshItem, onSuccess: () => qc.invalidateQueries({ queryKey: KEY }) });
}
